export enum MerchantProfileStep {
  loadingProfile = 0,
  directorDetails = 1,
  directorDocument = 2,
  primaryContact = 3,
  submitted = 4,
  settlementDetails = 5,
}
